import { ApiError } from '@/api/api.ts'
import { EmergencyAlertConfirmStatus } from '@/api/notification/getNotificationSos.ts'

export interface ILiveAlertSignature {
    assignedAt: string | null
    isMyTask: boolean
}

export type LiveAlertSyncAction = 'none' | 'refetch-detail' | 'advance-selection'

interface ILiveAlertLike {
    alert?: { taskManagerAt?: string | null; isMyTask?: boolean }
}

interface IDetailAlertLike {
    alert?: { confirm?: string; isMyTask?: boolean }
}

export const toLiveAlertSignature = (item?: ILiveAlertLike): ILiveAlertSignature | undefined => {
    if (!item) return undefined

    return {
        assignedAt: item.alert?.taskManagerAt || null,
        isMyTask: !!item.alert?.isMyTask
    }
}

export const decideLiveAlertSync = (
    previous: ILiveAlertSignature | undefined,
    current: ILiveAlertSignature | undefined,
    detail: IDetailAlertLike | undefined
): LiveAlertSyncAction => {
    if (!previous) return 'none'
    if (!current) return 'advance-selection'
    if (previous.assignedAt === current.assignedAt && previous.isMyTask === current.isMyTask) return 'none'
    if (!detail?.alert) return 'none'

    const { confirm, isMyTask } = detail.alert
    if (confirm === undefined) return 'refetch-detail'

    const detailMatchesLive =
        (confirm !== EmergencyAlertConfirmStatus.WAIT) === (current.assignedAt !== null) &&
        !!isMyTask === current.isMyTask

    return detailMatchesLive ? 'none' : 'refetch-detail'
}

export const isAlertStateConflict = (error: unknown): boolean =>
    error instanceof ApiError && (error.status === 400 || error.status === 409)
